<ui-sidebar-layout [navItems]="items()" [sidebarEnabled]="isAuthenticated()">
  <ng-template #logo>
    <img [src]="links.logoSrc" [alt]="links.logoAlt" class="w-45" />
  </ng-template>
  <ng-template #toolbar>
    @if (isAuthenticated()) {
      <p-button
        icon="fa-regular fa-arrow-right-from-bracket font-bold"
        [text]="true"
        (onClick)="logout()"
      ></p-button>
    }
  </ng-template>
  <ng-template #sidebarHeader>
    <span class="px-3 py-2 text-primary-500 font-bold block">
      <span class="text-[var(--p-secondary-500)]">IQ</span> Home</span
    >
  </ng-template>
  <!-- <ng-template #sidebarFooter>
    <app-tag-editor
      label="Label"
      [tags]="['A-Tag', 'B-Tag', 'C-Tag']"
      [selectedTags]="['D-Tag', 'C-Tag']"
    ></app-tag-editor>
  </ng-template> -->
  <ng-template #footer>
    <footer class="bg-surface-100 p-4 mt-auto">
      <div class="container mx-auto">
        <a
          class="nav-item px-3 py-2 text-primary-500 font-bold cursor-pointer"
          [href]="links.impressum"
          target="_blank"
          >{{ 'label.imprint' | translate }}</a
        >
      </div>
    </footer>
  </ng-template>
</ui-sidebar-layout>
<!-- <div class="flex flex-col min-h-screen">
  <header class="bg-white shadow-md">
    <p-menubar [model]="items()">
      <ng-template #start>
        <span class="px-3 py-2 text-primary-500 font-bold"
          ><span class="text-[var(--p-secondary-500)]">IQ</span> Home</span
        >
      </ng-template>
      <ng-template #item let-item let-root="root">
        <a
          pRipple
          class="flex items-center p-menubar-item-link"
          [routerLink]="[item.routerLink]"
          [routerLinkActive]="['active']"
        >
          <span [class]="item.icon" *ngIf="item.icon"></span>
          <span>{{ item.label | translate }}</span>
        </a>
      </ng-template>
      <ng-template #end>
        <div class="flex items-center">
          <img
            [src]="links.logoSrc"
            [alt]="links.logoAlt"
            class="h-20 w-auto"
          />
        </div>
      </ng-template>
    </p-menubar>
  </header>

  <main class="flex-grow container mx-auto p-4">
    <router-outlet></router-outlet>
  </main>

  <footer class="bg-surface-100 p-4 mt-auto">
    <div class="container mx-auto">
      <a
        class="nav-item px-3 py-2 text-primary-500 font-bold cursor-pointer"
        [href]="links.impressum"
        target="_blank"
        >{{ 'label.imprint' | translate }}</a
      >
    </div>
  </footer>
</div> -->
